import type { BuyContractPriceOption } from '@erp/rpc';
import type { VendorPriceBreakTier } from '@erp/rpc';
import type { LegPriceBreak } from '@erp/shared-types';
import { AgreementSavingNote } from './AgreementSavingNote';
import { BuyContractPriceSelect } from './BuyContractPriceSelect';
import { CostSourceBadge } from './CostSourceBadge';
import { VendorPriceBreakTierList } from './VendorPriceBreakTierList';

export function UnitCostPricingDropdownContent({
  tiers,
  options,
  priceBreak,
  quantity,
  disabled,
  onSelectContract,
}: {
  tiers: readonly VendorPriceBreakTier[];
  options: readonly BuyContractPriceOption[];
  priceBreak: LegPriceBreak | null | undefined;
  quantity: number | null | undefined;
  disabled: boolean;
  onSelectContract: (costAgreementId: string) => void;
}) {
  return (
    <div className="space-y-2 p-1">
      <VendorPriceBreakTierList tiers={tiers} />
      <CostSourceBadge priceBreak={priceBreak} />
      <AgreementSavingNote priceBreak={priceBreak} quantity={quantity} />
      <BuyContractPriceSelect
        options={options}
        priceBreak={priceBreak}
        disabled={disabled}
        onSelect={onSelectContract}
      />
    </div>
  );
}
